import { render, staticRenderFns } from "./songClassification.vue?vue&type=template&id=dc4a2978&scoped=true"
import script from "./songClassification.vue?vue&type=script&lang=js"
export * from "./songClassification.vue?vue&type=script&lang=js"
import style0 from "./songClassification.vue?vue&type=style&index=0&id=dc4a2978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4a2978",
  null
  
)

export default component.exports